import store from '@/store';
export default {
  methods: {
    can(permission) {
      if (store.getters.CURRENT_USER.is_super_admin === 1) {
        return true;
      }
      const arr = Object.keys(store.getters.USER_PERMISSIONS)
      return arr.includes(permission) ?? false
    },
    // hasPermission(moduleNames, pName = null) {
    //   if (store.getters.CURRENT_USER.is_super_admin === 1) {    //There are 4 situations so 4 if statments used
    //     return true;
    //   }
    //   if (typeof moduleNames === 'string' && pName === null) {
    //     return this.hasPermissionForModule(moduleNames); //true or false
    //   }

    //   if (typeof moduleNames === 'string' && pName !== null) {
    //     return this.hasPermissionForModule(moduleNames, pName); 
    //   }
    //   if (Array.isArray(moduleNames) && pName === null) {
    //     return moduleNames.some(module => this.hasPermissionForModule(module)); // Check for at least one module
    //   }
    //   if (Array.isArray(moduleNames) && pName !== null) {
    //     return moduleNames.some(module => this.hasPermissionForModule(module, pName)); // Check for permission in at least one module
    //   }
    // },
    // hasPermissionForModule(module, pName = null) {
    //   const rolePermissions = store.getters.CURRENT_USER_PERMISSIONS;
    //   const moduleObj = rolePermissions.permissions.find(mod => mod.module_name === module);

    //   if (!moduleObj) {
    //     return false;
    //   }
    //   if (pName === null) {
    //     return true;
    //   }
    //   if(pName != null) {
    //     return moduleObj.permission && moduleObj.permission.includes(pName); //true or false
    //   }
    // },
    getCallStatusColor(status) {
      switch (status) {
        case 'queued':
          return 'orange'
        case 'initiated':
        case 'ringing':
        case 'in-progress':
        case 'processing':
          return 'blue'
        case 'completed':
          return 'green'
        case 'failed':
        case 'busy':
        case 'no-answer':
        case 'canceled':
        case 'error':
          return 'red'
        case 'scheduled':
          return 'purple'
        default:
          return 'grey'
      }
    },
    getCallStatusLabel(status) {
      switch (status) {
        case 'queued':
          return 'Queued'
        case 'initiated':
          return 'Initiated'
        case 'ringing':
          return 'Ringing'
        case 'in-progress':
          return 'In-Progress'
        case 'completed':
          return 'Completed'
        case 'failed':
          return 'Failed'
        case 'busy':
          return 'Busy'
        case 'no-answer':
          return 'No-Answer'
        case 'canceled':
          return 'Canceled'
        case 'error':
          return 'Error'
        case 'scheduled':
          return 'Scheduled'
        case 'processing':
          return 'Processing'
        default:
          return 'Unknown'
      }
    },
    getSmsStatusColor(status) {
      switch (status) {
        case 'queued':
          return 'orange'
        case 'accepted':
          return 'orange'
        case 'sending':
        case 'processing':
        case 'sent':
          return 'blue'
        case 'delivered':
          return 'green'
        case 'undelivered':
        case 'failed':
        case 'error':
          return 'red';
        case 'scheduled':
          return 'purple'
        case 'canceled':
          return 'grey'
        case 'receiving':
        case 'received':
          return 'teal'
        default:
          return 'grey'
      }
    },
    getSmsStatusLabel(status) {
      switch (status) {
        case 'queued':
          return 'Queued'
        case 'accepted':
          return 'Accepted'
        case 'sending':
          return 'Sending'
        case 'sent':
          return 'Sent'
        case 'delivered':
          return 'Delivered'
        case 'undelivered':
          return 'Undelivered'
        case 'failed':
          return 'Failed'
        case 'scheduled':
          return 'Scheduled'
        case 'canceled':
          return 'Canceled'
        case 'receiving':
          return 'Receiving'
        case 'error':
          return 'Error'
        case 'received':
          return 'Received'
        case 'processing':
          return 'Processing'
        default:
          return 'Unknown'
      }
    },
    /**
    * @Description
    * Tells where an outgoing communication is holding while it is still on our side.
    * 'scheduled' and 'processing' never reached Twilio: 'scheduled' is the row as it
    * was created (waiting in our queue, or parked until a chosen time) and 'processing'
    * is the job having picked it up and being mid send. Anything else is Twilio's and
    * returns null so the caller can fall through to the Twilio reason instead.
    *
    * @param {Object} item - communication row
    * @returns {String|null} reason to show, or null when the row is no longer ours
    **/
    getOurSideStatusReason(item) {
      if (item?.status === 'processing') {
        return 'Processing on Our Side'
      }
      // 'scheduled' deliberately gets no icon: the chip already says Scheduled and
      // the Scheduled At column already shows when it goes out, so the extra icon
      // on every queued row was noise rather than information.
      return null
    },

    /**
    * @Description
    * Builds the reason Twilio gave for not delivering. Both parts are optional:
    * Twilio always sends the code but often omits the text, so the code alone is
    * still shown rather than nothing.
    *
    * @param {Object} item - communication row
    * @returns {String|null} reason to show, or null when Twilio reported no error
    **/
    getTwilioFailureReason(item) {
      if (!item?.error_code && !item?.error_message) {
        return null
      }
      if (!item?.error_message) {
        return `Twilio error ${item.error_code}`
      }
      return item?.error_code
        ? `${item.error_message} (Twilio error ${item.error_code})`
        : item.error_message
    },

    /**
    * @Description
    * Every status that means the message/call did not get through. Mirrors
    * CommunicationFailureReasonService::FAILED_STATUSES on the backend - keep the
    * two in step. Used to decide which rows get a reason icon at all.
    *
    * @param {String} status - communication status
    * @returns {Boolean}
    **/
    isFailedCommunicationStatus(status) {
      return [
        'not-delivered', 'error', 'not-completed', 'canceled',
        'undelivered', 'failed', 'busy', 'no-answer'
      ].includes(status)
    },

    formatDuration(duration) {
      const seconds = parseInt(duration, 10)
      const minutes = Math.floor(seconds / 60)
      const remainingSeconds = seconds % 60

      let result = []

      if (minutes > 0) {
        result.push(`${minutes} minute${minutes !== 1 ? 's' : ''}`)
      }

      if (remainingSeconds > 0 || minutes === 0) {
        result.push(`${remainingSeconds} second${remainingSeconds !== 1 ? 's' : ''}`)
      }

      return result.join(' ')
    },

    isMimeType(value) {
      return typeof value === 'string' && value.includes('/');
    },

    getFileExtension(value) {
      if (!value) return '';

      // If already a file extension (not MIME), return lowercase
      if (!this.isMimeType(value)) return value.toLowerCase();

      const map = {
        'application/pdf'   : 'pdf',
        'image/jpeg'        : 'jpeg',
        'image/jpg'         : 'jpg',
        'image/webp'        : 'webp',
        'image/png'         : 'png',
        'image/gif'         : 'gif',
        'image/bmp'         : 'bmp',
        'application/msword': 'doc',
        'audio/mpeg'        : 'mp3',
        'video/mp4'         : 'mp4',
        'video/x-msvideo'   : 'avi',
        'video/quicktime'   : 'mov',
        'text/html'         : 'html',
        'text/css'          : 'css',
        'text/plain'        : 'txt',
        'text/csv'          : 'csv',
        'application/zip'   : 'zip',
        'application/json'  : 'json',
        'application/x-rar' : 'rar',
        'application/javascript'        : 'js',
        'application/vnd.ms-excel'      : 'xls',
        'application/vnd.ms-powerpoint' : 'ppt',
        'application/x-rar-compressed'  : 'rar',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'   : 'docx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'         : 'xlsx',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation' : 'pptx',
      };

      return map[value.toLowerCase()] || value.split('/').pop().toLowerCase();
    },

    getFileIcon(input) {
      const ext = this.getFileExtension(input);

      const iconMap = {
        pdf   : 'mdi-file-pdf-box',
        jpg   : 'mdi-file-image',
        jpeg  : 'mdi-file-image',
        webp  : 'mdi-file-image',
        png   : 'mdi-file-png-box',
        gif   : 'mdi-file-gif-box',
        bmp   : 'mdi-file-image',
        doc   : 'mdi-file-word',
        docx  : 'mdi-file-word',
        xls   : 'mdi-file-excel',
        xlsx  : 'mdi-file-excel',
        ppt   : 'mdi-file-powerpoint',
        pptx  : 'mdi-file-powerpoint',
        txt   : 'mdi-text-box',
        csv   : 'mdi-file-delimited',
        zip   : 'mdi-folder-zip',
        rar   : 'mdi-folder-zip',
        mp3   : 'mdi-file-music',
        mp4   : 'mdi-file-video',
        avi   : 'mdi-file-video',
        mov   : 'mdi-file-video',
        html  : 'mdi-language-html5',
        css   : 'mdi-language-css3',
        js    : 'mdi-language-javascript',
        json  : 'mdi-code-json',
      };

      return iconMap[ext] || 'mdi-file';
    },

    getFileColor(input) {
      const ext = this.getFileExtension(input);

      const colorMap = {
        pdf   : 'red',
        doc   : 'blue',
        docx  : 'blue',
        xls   : 'green',
        xlsx  : 'green',
        ppt   : 'orange',
        pptx  : 'orange',
        jpg   : 'purple',
        jpeg  : 'purple',
        webp  : 'purple',
        png   : 'purple',
        gif   : 'purple',
        txt   : 'grey',
        csv   : 'grey',
        zip   : 'brown',
        rar   : 'brown',
        mp3   : 'deep-purple',
        mp4   : 'deep-purple',
        avi   : 'deep-purple',
        mov   : 'deep-purple',
        html  : 'orange darken-2',
        css   : 'blue lighten-2',
        js    : 'yellow darken-2',
        json  : 'teal',
      };

      return colorMap[ext] || 'grey';
    },
    onlyPositiveNumbersInput(e) {
      const invalidChars = ['-', 'e', 'E', '+']
      if (invalidChars.includes(e.key)) {
        e.preventDefault()
      }
    },
    vendorCount(vendors) {
      if (!vendors) return 0
      if (Array.isArray(vendors)) {
        return vendors.filter(Boolean).length
      }
      if (typeof vendors === 'string') {
        return vendors.split(',').map(v => v.trim()).filter(Boolean).length
      }
      return 0
    },
    truncateVendors(names) {
      const list = names.split(',').map(n => n.trim())
      const first = list[0]
      const count = list.length - 1
      return count > 0 ? `${first},...+${count} more`: first
    },
    formatDuration(seconds) {
      if (!seconds || isNaN(seconds)) {
        return "00:00"
      }
      const mins = Math.floor(seconds / 60)
      const secs = Math.floor(seconds % 60)
      return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
    },

    parseTimeString(timeStr) {
      if (!timeStr || typeof timeStr !== 'string') return Infinity
      if (timeStr === 'In Progress' || timeStr === 'Invalid Time Difference') {
        return Infinity 
      }
      let totalSeconds = 0
      const parts = timeStr.trim().split(' ')
      for (let i = 0; i < parts.length; i += 2) {
        const value = parseInt(parts[i])
        const unit = parts[i + 1] || ''
        if (unit.startsWith('day')) totalSeconds += value * 86400
        else if (unit.startsWith('hour')) totalSeconds += value * 3600
        else if (unit.startsWith('minute')) totalSeconds += value * 60
        else if (unit.startsWith('second')) totalSeconds += value
      }
      return totalSeconds
    },

    getStatusChip(status) {
      switch (status) {
        case 'REMOTE_PRINTED':
          return { color: 'blue', text: 'Remote_Printed' };
        case 'INSTANT_PRINTED':
          return { color: 'green', text: 'Instant_Printed' };
        case 'RE_PRINTED':
          return { color: 'orange', text: 'Re_Printed' };
        case 'PENDING':
          return { color: 'grey', text: 'Pending' };
        default:
          return { color: 'grey', text: status };
      }
    },

    formatForDatetimeLocal(rawDateString) {
      if (!rawDateString) return null
      const dateObj = new Date(rawDateString)

      if (isNaN(dateObj.getTime())) {
        console.error("Invalid date string provided to formatForDatetimeLocal", rawDateString)
        return null
      }
      const year = dateObj.getFullYear()
      const month = (dateObj.getMonth() + 1).toString().padStart(2, '0')
      const day = dateObj.getDate().toString().padStart(2, '0')
      const hours = dateObj.getHours().toString().padStart(2, '0')
      const minutes = dateObj.getMinutes().toString().padStart(2, '0')
      return `${year}-${month}-${day}T${hours}:${minutes}`
    },

    /**
    * @Description
    * Shorten a large count so it cannot overflow a narrow card - 196199 reads as
    * "196.2K". Anything below the threshold is left alone with plain thousands
    * separators, because "9,999" is both exact and short enough to fit; only
    * numbers that would actually break a layout get abbreviated. Always pair this
    * with formatFullNumber() somewhere reachable (tooltip/title) so the exact
    * figure is never lost.
    *
    * @param {Number|String} value - the raw count
    * @returns {String} compact label
    **/
    formatCompactNumber(value) {
      const n = Number(value || 0)
      if (!isFinite(n)) {
        return '0'
      }
      if (Math.abs(n) < 10000) {
        return n.toLocaleString()
      }

      const units = [
        { limit: 1e9, suffix: 'B' },
        { limit: 1e6, suffix: 'M' },
        { limit: 1e3, suffix: 'K' }
      ]
      let index = units.findIndex(u => Math.abs(n) >= u.limit)
      let scaled = n / units[index].limit

      // Rounding can push a value up into the next unit - 999,999 scales to 999.999
      // which rounds to 1000 and would otherwise print as the nonsense "1000K".
      if (Math.abs(scaled) >= 999.5 && index > 0) {
        index -= 1
        scaled = n / units[index].limit
      }

      // One decimal below 100, whole numbers above, and never a trailing ".0" -
      // so it reads "2M" rather than "2.0M".
      const rounded = Math.abs(scaled) >= 100 ? Math.round(scaled) : parseFloat(scaled.toFixed(1))

      return `${rounded}${units[index].suffix}`
    },

    /**
    * @Description
    * The exact count with thousands separators, for tooltips and title attributes
    * next to an abbreviated value
    *
    * @param {Number|String} value - the raw count
    * @returns {String} full number
    **/
    formatFullNumber(value) {
      return Number(value || 0).toLocaleString()
    },

    /**
    * @Description
    * Whether a value was shortened by formatCompactNumber, so callers can attach a
    * tooltip only where one is actually needed
    *
    * @param {Number|String} value - the raw count
    * @returns {Boolean}
    **/
    isCompactedNumber(value) {
      return Math.abs(Number(value || 0)) >= 10000
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 B'
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i]
    },
  }
}
